import type { FaireProductEntity } from "../../entity_types/product";

export const p_6gt7eqbh3b: FaireProductEntity = {
  token: "p_6gt7eqbh3b",
  type: "product",
  name: "Mini Sampler Gift Set",
  brandToken: "b_6v0qhuk6mq",
  brandName: "Fly By Jing",
  imageUrl:
    "https://cdn.faire.com/fastly/30e4656846a9425affa109a32e4605a8aab23d186588b3e7f64f1a3972b8b1b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d3151dae590c349b7375a0a6bfcc4ecb0705522ec96ac7c8d1f9ce7e20ddf73.jpeg",
    "https://cdn.faire.com/fastly/a83d64d92348be6abc119dcc8215f36499211483d8498111ec22ee1aa3bb496b.png",
    "https://cdn.faire.com/fastly/afdd05f9228e08fbae837533c2e9fdf0475cca93bae78ff315b6f98a8d08aed3.png",
  ],
  priceDollars: 11,
  description:
    "The hottest gift of 2025 -- a ready-to-gift limited edition gift set includes 3 jars of Fly By Jing’s best-selling spicy, savory chili crisp in 2 oz TSA compliant jars.\n\nEach gift set includes:\n• 2 oz. jar of Original Sichuan Chili Crisp: a bold, layered, crispy hot sauce that turns every meal more craveable\n• 2 oz. jar of Xtra Spicy Sichuan Chili Crisp: 3x the heat using the hottest Chinese chilis you can grow\n• 2 oz. jar of Xtra Crunchy Sichuan Chili Crisp: a nut-free extra crunchy condiment made to dip + dunk\n\nAll three hot sauces are Non-GMO Project Verified, vegan, and made without anything artificial or any gluten ingredients.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:35.691Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
